import { useEffect, useMemo, useState } from 'react';
export function useClientRectSize(element) {
    const [size, setSize] = useState([element?.clientWidth, element?.clientHeight]);
    useEffect(() => {
        function handleResize(entries) {
            const matchingEntry = entries.find(({ target }) => target == element);
            if (matchingEntry) {
                const { target, contentRect } = matchingEntry;
                setSize([contentRect.width, contentRect.height]);
            }
        }
        if (element) {
            setSize([element.clientWidth, element.clientHeight]);
            if (window.ResizeObserver) {
                const observer = new ResizeObserver(handleResize);
                observer.observe(element);
                return () => {
                    setSize([undefined, undefined]);
                    observer.disconnect();
                };
            }
            else {
                return () => {
                    setSize([undefined, undefined]);
                };
            }
        }
        if (element && window.ResizeObserver) {
            const observer = new ResizeObserver(handleResize);
            observer.observe(element);
            return () => {
                observer.disconnect();
            };
        }
    }, [element]);
    return size;
}
export function useParentClientRectSize() {
    const [element, setElement] = useState(null);
    const parent = useMemo(() => element?.parentElement ?? undefined, [element]);
    const [width, height] = useClientRectSize(parent);
    return [width, height, setElement];
}
//# sourceMappingURL=useClientRectSize.js.map